module.exports = __webpack_public_path__ + "assets/images/$100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$100.png
// module id = 1245
// module chunks = 1